export default __webpack_public_path__ + "static/assets/894ac83e502086770ad8d4379999644f.png";